webpackJsonp([115955860955844],{

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _images = __webpack_require__(147);
	
	var _images2 = _interopRequireDefault(_images);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrivacyPage = function PrivacyPage() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      {
	        style: {
	          fontFamily: "Helvetica, sans-serif",
	          fontSize: 20,
	          background: "#fff",
	          textRendering: "optimizeLegibility"
	        }
	      },
	      _react2.default.createElement(
	        "div",
	        { style: { paddingTop: 50 } },
	        _react2.default.createElement(
	          "div",
	          { style: { width: 260, margin: "0 auto" } },
	          _react2.default.createElement(
	            "a",
	            {
	              href: "/",
	              style: { display: "block", textDecoration: "none", outline: 0 }
	            },
	            _react2.default.createElement("img", {
	              src: _images2.default.logo,
	              alt: "Cliffhanger",
	              style: { width: "100%", maxWidth: "100%" }
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "content page" },
	      _react2.default.createElement(
	        "div",
	        { className: "hero" },
	        _react2.default.createElement(
	          "div",
	          { className: "lockup" },
	          _react2.default.createElement(
	            "div",
	            { className: "heading" },
	            _react2.default.createElement(
	              "h1",
	              { className: "title" },
	              "Privacy Policy"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        { style: { marginBottom: "1em" } },
	        "If you are an EU resident, the following",
	        " ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: (typeof window !== "undefined" ? window.location.origin : "") + "/legal/privacy_eu"
	          },
	          "Privacy Policy"
	        ),
	        " ",
	        "applies instead of the Privacy Policy below."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Hype Bits, Inc., and its affiliates (\u201CHype Bits\u201D, \u201Cus\u201D, \u201Cour\u201D or \u201Cwe\u201D) are dedicated to protecting the privacy rights of our users (\u201Cusers\u201D, \u201Cyour\u201D, or \u201Cyou\u201D). This Privacy Policy (the \u201CPolicy\u201D) describes the ways we collect, store, use, and manage the information, including personal information, that you provide or we collect in connection with our website at",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: typeof window !== "undefined" ? window.location.origin : "" },
	          "https://cliffhangerinteractive.com"
	        ),
	        " ",
	        "(the \u201CSite\u201D) or any Hype Bits game or application provided on other websites or other third party sources (collectively, the \u201CServices\u201D). Personal information can include, for example, an individual\u2019s first and last name, address, telephone number, e-mail address or credit card number. Please note that the scope of this Privacy Policy is limited to information collected or received by Hype Bits through your use of the Services. Hype Bits is not responsible for the actions of third party people or companies, the content of their sites, the use of information you provide to them, or any products or services they may offer. Any link to those sites does not constitute our sponsorship of, or affiliation with, those people or companies."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "BY DOWNLOADING, INSTALLING, USING OR OTHERWISE ACCESSING THE SERVICES, YOU AGREE TO THIS PRIVACY POLICY. IF YOU DO NOT AGREE TO THIS PRIVACY POLICY, YOU MAY NOT DOWNLOAD , INSTALL, USE OR OTHERWISE ACCESS THE SERVICES. We may update this Policy from time to time. You are responsible for periodically reading this Policy. We will post all changes to this Policy on this page and the modified policy will specify its effective date. You will be deemed to have accepted such changes to this Policy by continuing to use the Services."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Information Collected and Used"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Our primary objective in collecting your information is to provide and enhance the Services and to enable you to easily navigate and enjoy the Services. For example, Hype Bits may use your information to register your account, provide customer support, resolve disputes, collect fees, connect users, and notify you of updates to the game (or of other/new games) and special promotions."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "iOS or Android Platforms"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "When you use any of the Hype Bits games or applications, we may automatically collect and record certain information such as your unique device ID, MAC address, advertising identifier, OpenUDID, IMEI number, hardware type, the version of your operating system (\u201COS\u201D), your in-game activity, and your location (based on your Internet Protocol (\u201CIP\u201D) address). This information is useful to us for troubleshooting and helps us understand usage trends. It may also be used to contact you with in-game technical notices, updates, security alerts and support and administrative messages."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Hype Bits may use country information to customize the user experience and promotions, enforce our terms of service, and make recommendations about user connections."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "We may also give users the opportunity to opt-in to location-based services, which rely upon a device\u2019s GPS coordinates. You may opt-out of these location services via the settings on your device. A user\u2019s location may be used to suggest friends with whom they might want to connect, analyze usage trends or target certain promotions."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Some of our games or applications may permit a user to record his or her voice and share such recordings with an opponent in the context of such game or application. Hype Bits may use these recordings and post them as well as the contents of your play sessions on Facebook on a publicly available page (and link your data with your opponent). Hype Bits may store these recordings on its servers."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Google Server"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Google is our application engine service provider. Any information provided through our applications is available to Google as part of Google providing this service."
	      ),
	      "Platforms/Third-Party Marketplaces",
	      _react2.default.createElement(
	        "p",
	        null,
	        "In the course of providing our Services on third party platforms/marketplaces, such as Apple\u2019s App Store, the platforms/marketplaces may collect information about you or receive information from us in order for the platforms/marketplaces to provide or analyze their services. You acknowledge that these platforms/marketplaces were developed and administered by people or companies not affiliated with or controlled by Hype Bits and that Hype Bits is not responsible for the actions of those people or companies. You should carefully review the terms of service and privacy policies of the platforms/third-party marketplaces that you use to access our Services."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Facebook Connect"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "If you sign into the Services with Facebook Connect we may collect any information that is available via your Facebook account or the Facebook API, including your first and last name, Facebook ID, Profile Picture/URL, list of Facebook friends, gender, locale, list of your devices, email, likes, and interests that have been listed in your Facebook profile. This information will be primarily used for user registration and in social features, which may include friend-to-friend or user-to-user interaction, chat, voice or messaging functionality, public leaderboards, head-to-head competition and other similar features. It may also be used to analyze usage trends and offer users certain of our features, games or promotions that may be of particular interest to them."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "In-Game Dialog Boxes"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "When you register to play our games through the Services, we may ask whether you\u2019d like to provide us with certain pieces of information, which could include: your email, username, phone number, gender, birthdate, home address, and address book. We will do this through in-game dialog boxes, which you may choose to skip. If you provide your email address in connection with a Hype Bits game, the email address will be retained by Hype Bits and we may use that email address to contact you about your gaming experience with Hype Bits games and notify you about company news and promotions. We may also use part of your email address for friend-to-friend or user-to-user interaction and chat, voice or messaging functionality and other similar features. Your username may be used for social features in our games (e.g., presenting someone\u2019s name on a message board). Your phone number may be used to help connect you with other users via our social networking system and for SMS notifications. Your gender and birthdate may be used to analyze user trends and target certain promotions. Your home address will be used if we have merchandise or other physical promotional materials we want to send to you. We may also request access to your address book to connect you to other players in the game."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "If we begin offering our Services on a platform without an in-app purchase billing system, we may need to collect credit card and billing information."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Email Newsletter"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "You may elect to sign up for the Hype Bits email newsletter, which will contain information and advertisements about our products. We may also contact you with targeted email promotions."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Website"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "When you visit our Site, your computer\u2019s operating system, Internet Protocol (IP) address, access times, browser type and language and referring Web site addresses may be logged automatically. We may also collect information about your usage and activity, such as number of clicks, pages viewed and the order of those pages, the amount of time spent on particular pages, and the date and time of this activity. We may use this information to monitor and analyze use of the Services."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Other Collection"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "We may also acquire information from you through (1) your access and participation in message boards on the Services, (2) your email of a question to our customer support, (3) your purchase of a virtual product of any type, (4) your participation in surveys regarding the Services or (5) your participation in a sweepstakes or contest through the Services."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Cookies"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "A cookie is a small data file that we transfer to your computer\u2019s hard disk, generally to quickly identify a user\u2019s computer and to \u201Cremember\u201D things about the user\u2019s visit, such as your preferences or a username and password. The Services sends cookies to your computer when you access or view content of a Hype Bits game. Information contained in a cookie may be linked to your personal information for purposes such as improving the quality of our Services, tailoring recommendations to your interests, and making the Services easier to use. You can disable cookies at any time, although you may not be able to access or use features of the Services."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "We may feature advertisements served by third party advertising companies which deliver cookies to your computer so the ads you see can be tracked. Since the third party advertising companies tag your computer with a number, they will be able to recognize your computer each time they send you an advertisement. These advertisers may use information about your visits to our Services in order to provide advertisements about goods and services of interest to you."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Web Beacons"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "We may collect information using Web beacons. Web beacons or \u201Cgifs\u201D, are electronic images that may be used on our Site or in our emails. We may use Web beacons to deliver cookies, count visits and to tell if an email has been opened and acted upon."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Information for Opting-Out of Cookies and Web Beacons"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "You may click on the following link: http://www.networkadvertising.org (or such other URL as may be specified by us from time to time) for information on how to opt-out of the use of cookies or Web beacons."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Disclosure of Your Personal Information"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Hype Bits does not share your personal information except as approved by you or as described below:"
	      ),
	      _react2.default.createElement(
	        "ul",
	        null,
	        _react2.default.createElement(
	          "li",
	          null,
	          "With your consent, for example, when you agree to our sharing your information with other third parties for their own marketing purposes subject to their separate privacy policies."
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Hype Bits may engage other companies and individuals to perform services on our behalf, including, without limitation, sending e-mails to you and analyzing data."
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "We may release your information as permitted by law or when we believe that release is appropriate to comply with the law; enforce or apply our rights; or protect the rights, property, or safety of us or our users, or others. This includes exchanging information with other companies and organizations for fraud protection."
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Hype Bits may share your information in connection with any merger, sale of our assets, or a financing or acquisition of all or a portion of our business to another company."
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "We may share aggregate or anonymous information about you with advertisers, publishers, business partners, sponsors, and other third parties."
	        )
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Third Party Tools/Analytics"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "The Services may also contain third party tracking tools from third party service providers, which may enable these third parties to analyze our users\u2019 information. These third parties may have access to your personal information in connection with the performance of services for Hype Bits."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Advertisements"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "You may see our games advertised in other applications or websites. After clicking on one of these advertisements and installing our game, you will become a user of the Services. A device identifier and in-game or user session activity may be shared with the advertiser."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "We may use a third-party ad tracking service, Adjust, for tracking installs resulting from advertisements on other applications or sites. Please visit https://www.adjust.com/privacy_policy/ to see what type of information Adjust is collecting and using, including how you may opt out of such tracking services."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "You may see an \u201Coffer wall\u201D displayed in our games that is hosted by an offer wall provider. The offer wall enables advertisers to provide virtual currency to you in exchange for interacting with an advertisement or for completing a marketing offer with one of those advertisers. The offer wall providers may collect information about you, including a device identifier, device type, device brand, device model, OS type/version, network type, device language, device locale, and IP address. In addition, the offer wall provider may collect information related to the performance of the advertisements such as how many times an advertisement is shown, how long an advertisement is viewed, and any click-throughs of an advertisement."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "In addition, Hype Bits may have advertisements in its games regarding other applications or services that are served by third parties. These third parties may collect and use information about you, including platform, application and OS version, device identifiers, Media Access Control (MAC) address, International Mobile Equipment Identity (IMEI), Services user session activity, device usage information and general location information, such as locale (specific location where a given language is spoken), mobile network code/mobile country code, and time zone, to show advertising of interest to you. For example, Facebook serves advertising in certain of our applications and may target such advertisements based on information Facebook has collected from you. You can opt-out of such targeted advertisements by using Apple\u2019s \u201CLimit Ad Tracking\u201D setting described here: https://support.apple.com/en-us/HT202074. You can opt-out of interest based ads served by InMobi by downloading and using the Truste Ad Privacy Manager mobile application. Certain video ads are displayed in our games that are served by partners such as Ad Colony, Flurry, Applovin and Vungle and which may target users based on certain information that such third party has obtained regarding users. You can opt out of Ad Colony targeted advertising by visiting http://privacy.adcolony.com/opt-out, opt out of Flurry targeted advertising by visiting http://www.flurry.com/user-opt-out.html, opt out of Applovin targeted advertising by following the instructions at https://www.applovin.com/optout, and opt out of Vungle targeted advertising by following the instructions available here http://www.vungle.com/privacy/. Such third parties serving advertisements may also collect information related to the performance of the advertisements such as how many times an advertisement is shown, how long an advertisement is viewed, and any click-throughs of an advertisement."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Changing or Deleting Your Information"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "You may contact us regarding any questions or comments regarding this Privacy Policy by contacting us at",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "https://cliffhangersupport.zendesk.com/hc/en-us/requests/new" },
	          "https://cliffhangersupport.zendesk.com/hc/en-us/requests/new"
	        ),
	        ". If you completely delete all of your information, your account may become deactivated. You may opt-out of receiving promotional emails from us by following the instructions in those emails. If you opt-out, we may still send you non-promotional emails, such as emails about your accounts or our ongoing business relations."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Under California law, California Residents who have an established business relationship with us may choose to opt out of the disclosure of personal information about them to third parties for such third parties\u2019 direct marketing purposes. As detailed above, our policy is not to disclose personal information collected online to a third party for direct marketing purposes without your approval. If you choose to opt-out at any time after granting approval,",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "https://cliffhangersupport.zendesk.com/hc/en-us/requests/new" },
	          "https://cliffhangersupport.zendesk.com/hc/en-us/requests/new"
	        ),
	        "."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Security"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Hype Bits has put in place technical and organizational measures designed to secure your information from accidental loss and from unauthorized access, use, alteration or disclosure. However, we cannot guarantee that unauthorized third parties will never be able to overcome those measures or use your personal information for improper purposes. Also please note that email and messaging systems are not considered secure, so we discourage you from sending us personal information through these mediums."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Do Not Track"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "We currently do not participate in any \u201CDo Not Track\u201D frameworks that would allow us to respond to signals or other mechanisms from you regarding the collection of your information. We may engage third parties, such as marketing or analytics partners, who may collect information about your online activities over time and across different websites when you use our website."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "International Transfer"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "We may transfer information that we collect about you to affiliated entities, or to other third parties across borders and from your country or jurisdiction to other countries or jurisdictions around the world. If you are located in the European Union or other regions with laws governing data collection and use that may differ from U.S. law, please note that you are transferring information, including personal information, to a country and jurisdiction that does not have the same data protection laws as your jurisdiction, and you consent to the transfer of information to the U.S. and the use and disclosure of information about you, including personal information, as described in this Policy."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Contacting Us"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "If you have any questions about this Privacy Policy, please contact us at",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "https://cliffhangersupport.zendesk.com/hc/en-us/requests/new" },
	          "https://cliffhangersupport.zendesk.com/hc/en-us/requests/new"
	        ),
	        "."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Effective Date: June 12, 2017"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Hype Bits, Inc. (\u201CHype Bits\u201D) respects the intellectual property of others and asks that users of Hype Bits\u2019 services do the same. In connection with the services, Hype Bits has implemented a policy (below) that provides for the removal of any infringing materials in appropriate circumstances."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Notice Procedure. If you believe that your work has been copied in a way that constitutes infringement of a copyright or other intellectual property, please provide Hype Bits\u2019 Copyright Agent (as identified below) the following information:"
	      ),
	      _react2.default.createElement(
	        "ul",
	        null,
	        _react2.default.createElement(
	          "li",
	          null,
	          "An electronic or physical signature of the person authorized to act on behalf of the owner of the copyright or other intellectual property interest;"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "A description of the copyrighted work or other intellectual property that you claim has been infringed;"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "A description of where the material that you claim is infringing is located on the services;"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Your name, address, telephone number and email address;"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "A statement by you that you have a good faith belief that the disputed use is not authorized by the copyright owner, its agent, or the law; and"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "A statement by you, made under penalty of perjury, that the above information in your notice is accurate and that you are the copyright or intellectual property owner or authorized to act on the copyright or intellectual property owner\u2019s behalf."
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Counter-Notice Procedure. If you believe that your submission of content to our services was removed (or access to which was disabled) as a result of a notice of infringement and that the content is not infringing, or that you have the authorization from the copyright owner, the copyright owner\u2019s agent, or pursuant to the law, to post and use the content on the services, you may send to the Copyright Agent a counter-notice containing the following information:"
	      ),
	      _react2.default.createElement(
	        "ul",
	        null,
	        _react2.default.createElement(
	          "li",
	          null,
	          "Your electronic or physical signature;"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Identification of the content that has been removed (or to which access was disabled) and the location at which the content appeared before it was removed or disabled;"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "A statement that you have a good faith belief that the content was removed or disabled as a result of mistake or a misidentification of the content; and"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Your name, address, telephone number and e-mail address,"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "A statement that you consent to the jurisdiction of the U.S. Federal courts located in San Francisco County, California; and"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "A statement that you will accept service of process from the person who provided notification of the alleged infringement."
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "If a counter-notice is received by the Copyright Agent, Hype Bits may send a copy of the counter-notice to the original complaining party informing that person that it may replace the removed content or cease disabling it in ten business days. Unless the copyright owner files an action seeking a court order against the content provider, member or user, the removed content may be replaced, or access to it restored, in ten to fourteen business days (or more) after receipt of the counter-notice. Replacement or restoration of access to the content shall be in Hype Bits\u2019 sole discretion."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Please note that any misrepresentation of any material fact in any notice above may automatically subject you to liability for any related damages, costs and attorney fees incurred by Hype Bits pursuant to 17 U.S.C. Section 512(f)."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Hype Bits\u2019 Copyright Agent, for notice of claims of infringement and counter-notices, can be reached as follows:"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "By mail:"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Hype Bits, Inc."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Attn: Copyright Agent"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "3500 South DuPont Highway"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Dover, DE 19901"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "By telephone: 415-371-1333"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "By fax: 866-582-9178"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Support:",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "https://cliffhangersupport.zendesk.com/hc/en-us/requests/new" },
	          "https://cliffhangersupport.zendesk.com/hc/en-us/requests/new"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "footer" },
	      _react2.default.createElement(
	        "a",
	        { href: "/legal/copyright/" },
	        "Copyright"
	      ),
	      _react2.default.createElement(
	        "a",
	        { href: "/legal/privacy/" },
	        "Privacy Policy"
	      ),
	      _react2.default.createElement(
	        "a",
	        { href: "/legal/subscription/" },
	        "Subscription"
	      ),
	      _react2.default.createElement(
	        "a",
	        { href: "/legal/terms/" },
	        "Terms of Service"
	      )
	    )
	  );
	};
	
	exports.default = PrivacyPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-legal-privacy-js-bcf556b6de80633dbbbf.js